import type { IntlShape } from 'react-intl'
import type { PaymentHeader, PaymentFormInput } from './types'

export const paymentHeaders: PaymentHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritukset',
				description: 'Table column header: Payments',
			}),
		key: 'payments',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: Date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Table column header: Additional Information',
			}),
		key: 'additionalInformation',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksettu',
				description: 'Table column header: Amount Paid',
			}),
		key: 'paidAmount',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritustapa',
				description: 'Table column header: Payment Method',
			}),
		key: 'paymentMethod',
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const paymentFormHeaders: PaymentFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksupäivä',
				description: 'Payment date',
			}),
		key: 'paymentDate', //TODO:
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritustapa',
				description: 'Payment method',
			}),
		key: 'paymentMethod', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional information',
			}),
		key: 'additionalInformation', //TODO:
		show: true,
		type: 'string',
		fullWidth: true,
	},
]

export const paymentFormTableHeaders: PaymentFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lasku',
				description: 'Invoice',
			}),
		key: 'invoice', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksu pvm',
				description: 'Payment date',
			}),
		key: 'paymentDate', //TODO:
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional information',
			}),
		key: 'additionalInformation', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avoin summa',
				description: 'Open amount',
			}),
		key: 'openAmount', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksettu',
				description: 'Paid',
			}),
		key: 'paid', //TODO:
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency',
			}),
		key: 'currency', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Erotus',
				description: 'Difference',
			}),
		key: 'difference', //TODO:
		show: true,
		type: 'number',
	},
]

export const paymentViewHeaders: PaymentHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritukset',
				description: 'Table column header: Payments',
			}),
		key: 'payments',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: Date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritustapa',
				description: 'Table column header: Payment Method',
			}),
		key: 'paymentMethod',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksettu',
				description: 'Table column header: Amount Paid',
			}),
		key: 'paidAmount',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tosite',
				description: 'Table column header: Document',
			}),
		key: 'document',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Table column header: Additional Information',
			}),
		key: 'additionalInformation',
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const paymentsTableHeaders: PaymentHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lasku',
				description: 'Table column header: Invoice',
			}),
		key: 'invoice',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksu pvm',
				description: 'Table column header: Payment Date',
			}),
		key: 'paymentDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Table column header: Additional Information',
			}),
		key: 'additionalInformation',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yhteensä',
				description: 'Table column header: Total',
			}),
		key: 'total',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency',
		show: true,
		sortable: true,
		type: 'number',
	},
]
